import { render, staticRenderFns } from "./train-cleaning.vue?vue&type=template&id=c987aa42&scoped=true"
import script from "./train-cleaning.vue?vue&type=script&lang=js"
export * from "./train-cleaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c987aa42",
  null
  
)

export default component.exports